import ForgotPasswordForm from '~/src/components/auth/forgot-password/ForgotPasswordForm'
import ForgotPasswordTitle from '~/src/components/auth/forgot-password/ForgotPasswordTitle'
import ResponsiveDialog from '~/src/components/mui-wrappers/responsive-dialog'
import { DialogNameEnum } from '~/src/types/DialogNameEnum'
import { useMediaQuery } from '@mui/material'
import { CustomMuiTheme } from '~/src/hooks/useCustomMuiTheme'

export interface ForgotPasswordDialogProps {
  onClose?(): void,
}

const ForgotPasswordDialog = ({ onClose }: ForgotPasswordDialogProps) => {
  const isSmallDevice = useMediaQuery((theme: CustomMuiTheme) => theme.breakpoints.down('md'))

  return (
    <ResponsiveDialog
      openByDefault={true}
      showPuller={isSmallDevice}
      showCloseButton
      name={DialogNameEnum.AUTH_FORGOT_PASSWORD}
      Title={<ForgotPasswordTitle />}>
      <ForgotPasswordForm
        fieldsColor='container'
        onClose={onClose} />
    </ResponsiveDialog>
  )
}

export default ForgotPasswordDialog
